module.exports = __webpack_public_path__ + "img/outlander_base.42f71631.jpg";